import React from "react";

const getInitials = name => {
  if (!name || typeof name !== "string") return "U"; // Default initial for undefined names

  const words = name.trim().split(" ");

  // Handle cases with only one word
  if (words.length === 1) {
    return words[0][0]?.toUpperCase() || "U"; // Ensure a letter exists
  }

  // Handle cases with multiple words
  return (words[0][0] + (words[1]?.[0] || "")).toUpperCase();
};

const Avatar = ({ name, imageUrl }) => {
  return imageUrl ? (
    <img src={imageUrl} alt={name} className="avatar-image" />
  ) : (
    <div className="avatar-initials">{getInitials(name)}</div>
  );
};

export default Avatar;
